import React, { useState, useEffect } from 'react';
import { db } from "../firebase";
import { ref, onValue, update, get, push } from "firebase/database";
import Swal from 'sweetalert2';
import { MdCheck, MdClose, MdContentCopy, MdAccessTime } from 'react-icons/md';
import './AdminWithdrawal.css';

const AdminWithdrawal = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const withdrawRef = ref(db, 'withdrawals');
        onValue(withdrawRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                // Sirf pending requests dikhane ke liye
                const list = Object.keys(data).map(key => ({
                    requestId: key,
                    ...data[key]
                })).filter(r => r.status === 'pending');
                
                setRequests(list.sort((a, b) => b.timestamp - a.timestamp));
            } else {
                setRequests([]);
            }
            setLoading(false);
        });
    }, []);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        Swal.fire({
            title: 'Copied!',
            toast: true,
            position: 'top-end',
            timer: 1500,
            showConfirmButton: false,
            icon: 'success'
        });
    };

    const handleAction = async (request, action) => {
        const result = await Swal.fire({
            title: `Confirm ${action}?`,
            text: `${request.username} | ${request.amount} USDT`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: action === 'approve' ? '#2ecc71' : '#e74c3c',
            confirmButtonText: `Yes, ${action}`
        });

        if (result.isConfirmed) {
            try {
                // User side history filter "Success" ya "Rejected" use karti hai
                const finalStatus = action === 'approve' ? 'Success' : 'Rejected';

                if (action === 'approve') {
                    // Seedha status update karein withdrawals node mein
                    await update(ref(db, `withdrawals/${request.requestId}`), { 
                        status: finalStatus,
                        processedAt: new Date().toISOString() 
                    });
                } else {
                    // Reject hone par balance refund karna lazmi hai
                    const userRef = ref(db, `users/${request.username}`);
                    const userSnap = await get(userRef);
                    
                    if (userSnap.exists()) {
                        const currentBalance = parseFloat(userSnap.val().balance || 0);
                        const refundedBalance = (currentBalance + parseFloat(request.amount)).toFixed(2);
                        
                        // Atomic update: Balance refund aur status change ek saath
                        await update(ref(db), {
                            [`/users/${request.username}/balance`]: refundedBalance,
                            [`/withdrawals/${request.requestId}/status`]: finalStatus,
                            [`/withdrawals/${request.requestId}/processedAt`]: new Date().toISOString()
                        });
                    }
                }
                
                Swal.fire({
                    title: 'Updated!',
                    text: `Request for ${request.username} ${action}d.`,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
                
            } catch (e) { 
                Swal.fire('Error', e.message, 'error'); 
            }
        }
    };

    if (loading) return <div className="admin-loader">Loading...</div>;

    return (
        <div className="compact-withdraw-container">
            <div className="compact-header">
                <div className="header-title">
                    <h2>Withdrawal Management</h2>
                    <span className="pending-badge">{requests.length} Pending</span>
                </div>
            </div>

            <div className="table-responsive">
                <table className="compact-table">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Amount</th>
                            <th>Method</th>
                            <th>Address</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {requests.length > 0 ? requests.map((req) => (
                            <tr key={req.requestId}>
                                <td className="user-cell">@{req.username}</td>
                                <td className="amount-cell">{req.amount}<span> USDT</span></td>
                                <td className="method-cell">
                                    <span className="net-tag">TRC20</span> {req.walletName || 'Tether'}
                                </td>
                                <td className="address-cell">
                                    <div className="copy-wrapper">
                                        <code>{req.address ? `${req.address.substring(0, 8)}...${req.address.slice(-4)}` : 'N/A'}</code>
                                        <button onClick={() => copyToClipboard(req.address)} className="copy-mini-btn">
                                            <MdContentCopy size={14} />
                                        </button>
                                    </div>
                                </td>
                                <td className="action-cell">
                                    <button className="btn-approve" onClick={() => handleAction(req, 'approve')}><MdCheck /></button>
                                    <button className="btn-reject" onClick={() => handleAction(req, 'reject')}><MdClose /></button>
                                </td>
                            </tr>
                        )) : (
                            <tr><td colSpan="5" className="empty-msg">No pending requests found.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminWithdrawal;